<template>
  <b-container fluid class="p-0 kub-summary-progress pb-2 mt-0">
    <b-row>
      <b-col class="p-0">
        <div class="pt-2 d-flex justify-content-between">
          <span>
            <b-row @click="shoppingCartComplete ? changeStepShoppingCart() : ''" :style="shoppingCartComplete ? 'cursor:pointer;' : 'cursor:not-allowed'">
              <b-col class="d-flex justify-content-center">
                <div class="kub-step kub-step-current" v-if="!shoppingCartComplete"></div>
                <div class="kub-step-done d-flex justify-content-center align-items-center" v-else>
                  <b-icon icon="check" scale="1.5"></b-icon>
                </div>
              </b-col>
              <div class="w-100"></div>
              <b-col class="d-flex justify-content-center kub-step-title-done">
                <span v-if="sm" class="kub-summary-progress-title">{{steps.shoppingCart.titleLong}}</span>
                <span v-else class="kub-summary-progress-title">{{steps.shoppingCart.titleShort}}</span>
              </b-col>
            </b-row>
          </span>
          <span class="kub-divider" :class="{'kub-divider-done': shoppingCartComplete}"></span>
          <span>
            <b-row @click="addressComplete ? changeStepAddress() : ''" :style="addressComplete ? 'cursor:pointer;' : 'cursor:not-allowed'">
              <b-col class="d-flex justify-content-center">
                <div class="kub-step" :class="{'kub-step-current': shoppingCartComplete}" v-if="!addressComplete"></div>
                <div class="kub-step-done d-flex justify-content-center align-items-center" v-else>
                  <b-icon icon="check" scale="1.5"></b-icon>
                </div>
              </b-col>
              <div class="w-100"></div>
              <b-col class="d-flex justify-content-center" :class="{'kub-step-title-done': shoppingCartComplete}">
                <span v-if="sm" class="kub-summary-progress-title">{{steps.address.titleLong}}</span>
                <span v-else class="kub-summary-progress-title">{{steps.address.titleShort}}</span>
              </b-col>
            </b-row>
          </span>
          <span class="kub-divider" :class="{'kub-divider-done': addressComplete}"></span>
          <span>
            <b-row>
              <b-col class="d-flex justify-content-center">
                <div class="kub-step" :class="{'kub-step-current': addressComplete}" v-if="!paymentComplete"></div>
                <div class="kub-step-done d-flex justify-content-center align-items-center" v-else>
                  <b-icon icon="check" scale="1.5"></b-icon>
                </div>
              </b-col>
              <div class="w-100"></div>
              <b-col class="d-flex justify-content-center" :class="{'kub-step-title-done': addressComplete}">
                <span v-if="sm" class="kub-summary-progress-title">{{steps.payment.titleLong}}</span>
                <span v-else class="kub-summary-progress-title">{{steps.payment.titleShort}}</span>
              </b-col>
            </b-row>
          </span>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import Data from '../../../data/main/summary/summaryProgress'

import { mapGetters, mapActions } from 'vuex'

export default {
  data () {
    return {
      steps: Data.steps
    }
  },
  methods: {
    ...mapActions([
      'changeStatusShoppingCart',
      'changeStatusAddress'
    ]),
    changeStepShoppingCart () {
      this.changeStatusShoppingCart()
      if (this.addressComplete) {
        this.changeStatusAddress()
      }
      this.$root.$emit('bv::toggle::collapse', 'kub-cart')
      if (!this.lg) {
        document.getElementById('kub-cart').scrollIntoView()
      }
    },
    changeStepAddress () {
      this.changeStatusAddress()
      this.$root.$emit('bv::toggle::collapse', 'kub-address')
      if (!this.lg) {
        document.getElementById('kub-address').scrollIntoView()
      }
    }
  },
  computed: {
    ...mapGetters([
      'width',
      'xs',
      'sm',
      'md',
      'lg',
      'xl',
      'shoppingCartComplete',
      'addressComplete',
      'paymentComplete'
    ])
  }
}
</script>

<style scoped>
.kub-summary-progress {
  color:#777877;
  background-color: #fff;
  margin-bottom: 1rem;
  padding-left: 0 !important;
  padding-right: 0 !important;
}

.kub-divider {
  flex-grow: 1;
  border-bottom: 2px solid #ddd;
  margin-bottom: 37px;
  margin-left: -60px;
  margin-right: -60px;
}

.kub-divider-done {
  border-bottom: 2px solid #002b36;
}

.kub-step {
  background-color: #ddd;
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 50%;
  border: 1px solid #ddd;
}

.kub-step-current {
  background-color: #002b36;
  border: 1px solid #002b36;
}

.kub-step-done {
  background-color: #002b36;
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 50%;
  color: #fff;
}

.kub-step-title-done {
  color: #002b36;
}

.kub-summary-progress-title {
  font-size: 1rem;
  margin-bottom: 0.5rem;
  font-weight: 500;
  line-height: 1.2;
}

@media (max-width: 575px) {
  .kub-summary-progress {
    margin-top: 1rem;
    margin-bottom: 1rem;
  }
}
</style>
